export interface OC {
  id?: string | null
  createdAt?: Date | null
  tipoOC?: TipoOC | null
  numeroOC?: string | null
  fechaPago?: string | null
  tipoEgreso?: TipoEgreso | null
  categoriaEgreso?: null | string
  proveedor?: Proveedor | null
  moneda?: string | null
  montoPagar?: number | null
  observaciones?: string | null
  estado?: Estado | null
  items?: Item[] | null
  tipoOrden?: 'Orden de Compra' | null
}
interface Item {
  numeroItem?: null
  descripcion?: string | null
  cantidad?: number | null
  precioUnitario?: number | null
}
interface Proveedor {
  id?: string | null
  nombreProveedor?: string | null
  numRUC?: string | null
}
enum Estado {
  Creado = 'CREADO',
  Rechazado = 'RECHAZADO'
}

enum TipoEgreso {
  Financiamiento = 'FINANCIAMIENTO',
  Inversion = 'INVERSION',
  Operativos = 'OPERATIVOS'
}

enum TipoOC {
  Administrativo = 'Administrativo',
  Financiero = 'Financiero',
  Operativo = 'Operativo'
}
